import { createAction } from '@reduxjs/toolkit';

import type { ChartRequest, ConversationItem } from './aiChatTypes';

export const appendResponse = createAction<{ conversationId: string; item: ConversationItem; charts?: ChartRequest[] }>(
  'aiChatStore/appendResponse',
);
export const appendStreamingDelta = createAction<{ conversationId: string; delta: string }>(
  'aiChatStore/appendStreamingDelta',
);
export const appendReasoningDelta = createAction<{ conversationId: string; delta: string }>(
  'aiChatStore/appendReasoningDelta',
);
export const clearStreamingMessage = createAction<string>('aiChatStore/clearStreamingMessage');
export const clearReasoningMessage = createAction<string>('aiChatStore/clearReasoningMessage');
export const closeChat = createAction('aiChatStore/closeChat');
export const setConversationError = createAction<{ conversationId: string; error: string | null }>(
  'aiChatStore/setConversationError',
);
export const setConversationLoading = createAction<{ conversationId: string; loading: boolean }>(
  'aiChatStore/setConversationLoading',
);
export const setReasoningMessage = createAction<{ conversationId: string; message: string | null }>(
  'aiChatStore/setReasoningMessage',
);
export const setThreadTitle = createAction<{ conversationId: string; title: string }>('aiChatStore/setThreadTitle');
